import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useLead } from '../contexts/LeadContext';
import { QueenPicker } from './QueenPicker';

/** Modal wrapper around the shared QueenPicker, driven by LeadContext. */
export function QueenPickerModal() {
  const {
    t
  } = useLanguage();
  const {
    pickerOpen,
    pickerContext,
    closePicker
  } = useLead();
  const panelRef = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (!pickerOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') closePicker();
    };
    document.addEventListener('keydown', onKey);
    panelRef.current?.focus();
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [pickerOpen, closePicker]);
  return <AnimatePresence data-id="element-237" data-mp="2ncoa5s13zrcv">
      {pickerOpen && <motion.div className="fixed inset-0 z-[60] flex items-end justify-center bg-ink/70 p-0 backdrop-blur-sm sm:items-center sm:p-6" initial={reduce ? undefined : {
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={reduce ? undefined : {
      opacity: 0
    }} transition={{
      duration: 0.25
    }} onClick={closePicker} data-id="element-238" data-mp="2ndzepu2dp351">
          <motion.div ref={panelRef} role="dialog" aria-modal="true" aria-labelledby={`queen-picker-title-${pickerContext}`} tabIndex={-1} onClick={e => e.stopPropagation()} initial={reduce ? undefined : {
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={reduce ? undefined : {
        opacity: 0,
        y: 15
      }} transition={{
        duration: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative max-h-[92vh] w-full max-w-xl overflow-y-auto border-t-2 border-camel bg-white p-6 shadow-2xl sm:p-8" data-id="element-239" data-mp="23o735kjvu5zj">
            <button type="button" onClick={closePicker} aria-label={t('picker.close')} className="absolute right-3 top-3 flex h-12 w-12 items-center justify-center text-muted transition-colors hover:text-ink" data-id="element-240" data-mp="gtk1ax54k15v">
              <XIcon aria-hidden="true" className="h-5 w-5" data-id="element-241" data-mp="vqb6xo5e693x" />
            </button>
            <QueenPicker context={pickerContext} tone="light" onSelected={closePicker} data-id="element-242" data-mp="zrd3fx7xc727" />
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}